export default "__VITE_ASSET__qI_tIjf9__"